import requester from '@/utils/request'
export default {
  // 申请提现
  applyWithdraw: (data: any) => requester.post('/seller/usd-withdraw/task/apply', data, { headers: { isSeller: true } }),
  // 提现历史列表（任务）
  queryTaskList: (data: any) => requester.post('/seller/usd-withdraw/task/list', data, { headers: { isSeller: true } }),
  // 发送验证码
  sendVerificationCode: () => requester.post('/seller/usd-withdraw/task/verification-code/send', {}, { headers: { isSeller: true } }),
  // 美金账户列表
  queryUsdAccountList: (data: any) => requester.post('/seller/usd-withdraw/account/list', data, { headers: { isSeller: true } }),
  // 添加/修改 美金账户
  updateUsdAccount: (data: any) => requester.post('/seller/usd-withdraw/account/upsert', data, { headers: { isSeller: true } }),
}
